import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Motor from "../components/equipments/Motor";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const MotorPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "موتور خانه",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <Motor />
          <RoomEquipmentsList />
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default MotorPage;
